import isADevice from "../utils/isADevice";

/**
 * Payment period configuration with visibility rules
 * Each period has an isVisible function that returns true when the period should be displayed
 */
export const PAYMENT_PERIODS = [
  {
    value: "month",
    label: "Mensual",
    isVisible: (context) => {
      const { vehicleData, mobility } = context;

      if (
        ["scooter", "other", "otro"].includes(vehicleData.type) &&
        vehicleData.valueUser < 40_000
      ) {
        return false;
      }

      if (
        (vehicleData.type === "auto" && vehicleData.valueUser < 100000) ||
        (vehicleData.type === "moto" && vehicleData.valueUser < 30000)
      ) {
        return false;
      }

      if (isADevice(vehicleData.type) && mobility === 0) {
        return false;
      }

      return true;
    },
  },
  {
    value: "3month",
    label: "Trimestral",
    isVisible: (context) => {
      // WOW users CANNOT see quarterly
      return !context.isWowUser;
    },
  },
  {
    value: "6month",
    label: "Semestral ",
    isVisible: (context) => {
      // WOW users CANNOT see semi-annual
      return !context.isWowUser;
    },
  },
  {
    value: "year",
    label: "Anual",
    isVisible: () => {
      return true; // Always visible
    },
  },
];

/**
 * Gets the list of payment periods that should be visible based on the current context
 * @param {Object} context - The context object containing vehicleData, mobility, and isWowUser
 * @returns {Array} Array of visible payment period configurations
 */
export function getVisiblePaymentPeriods(context) {
  return PAYMENT_PERIODS.filter((period) => period.isVisible(context));
}
